import { useTranslation } from 'react-i18next';
import { Button } from '@robocorp/components';
import { useCurrentOrFirstOrganization } from '~/queries';

export const StartUsingAgentButton = () => {
  const { t } = useTranslation();
  const { data: currentOrganization } = useCurrentOrFirstOrganization();

  const currentOrganizationId = currentOrganization?.id;
  if (!currentOrganizationId) {
    return null;
  }

  const agentUIUrl = `${window.location.origin}/agents/org/${currentOrganizationId}/gallery`;
  return (
    <Button
      href={agentUIUrl}
      forwardedAs="a"
      data-testid="navigation__start-using-agents"
      id="start_using_agents"
    >
      {t('startUsingAgents')}
    </Button>
  );
};
